module.exports = __webpack_public_path__ + "static/img/69013B_5_6_R_20200630_LC.79f64cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/69013B_5_6_R_20200630_LC.png
// module id = PwaQ
// module chunks = 0